import { useCallback, useRef, useState } from "react";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { TbArrowLeft } from "react-icons/tb";
import { ModalCloseButton } from "../../../../Components/Molecules/ValutDialog";
import {
  PIX_QR_RECEIVE_FORM_ID,
  PixQrReceiveContent,
} from "./PixQrReceiveContent";

const MODAL_PAPER_MOBILE = "!flex !flex-col !h-full !overflow-x-hidden !shadow-card app-card";
const MODAL_PAPER_BASE =
  "!rounded-2xl !shadow-card app-card !m-4 !flex !flex-col !max-h-[94vh] !w-full !max-w-[calc(100vw-2rem)] !overflow-x-hidden";
const MODAL_PAPER_CLASS = `${MODAL_PAPER_BASE} sm:!max-w-4xl`;

export const PixQrReceiveModal = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const contentRef = useRef(null);
  const [step, setStep] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [canContinue, setCanContinue] = useState(false);

  const handleStepChange = useCallback(
    ({ step: nextStep, isSubmitting: submitting, canContinue: nextCanContinue }) => {
      setStep(nextStep);
      setIsSubmitting(submitting);
      setCanContinue(Boolean(nextCanContinue));
    },
    []
  );

  const handleDialogClose = (_, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      className="pix-qr-receive-modal"
      open={open}
      onClose={handleDialogClose}
      disableEscapeKeyDown
      fullScreen={isMobile}
      fullWidth
      maxWidth="lg"
      scroll="paper"
      PaperProps={{ className: isMobile ? MODAL_PAPER_MOBILE : MODAL_PAPER_CLASS }}
    >
      <div className="relative flex min-h-0 flex-1 flex-col">
        <ModalCloseButton
          onClick={onClose}
          disabled={isSubmitting}
          className="absolute right-3 top-3 z-10"
        />

        <div className="min-w-0 flex-1 overflow-x-hidden overflow-y-auto px-4 py-4 sm:px-6 sm:py-5">
          <h2 className="pr-8 text-lg font-bold text-brand-dark">Receber por Pix</h2>
          <p className="mt-0.5 text-sm text-gray-500">
            Gere um QR Code e compartilhe o código copia e cola para receber pagamentos.
          </p>

          <div className="mt-3">
            <PixQrReceiveContent
              ref={contentRef}
              isActive={open}
              footerInModal
              onStepChange={handleStepChange}
            />
          </div>
        </div>

        <div className="pix-qr-receive-modal__footer mt-auto shrink-0 border-t border-gray-100 px-4 pb-4 pt-3 sm:px-6">
          {step === 0 && (
            <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
              <button
                type="submit"
                form={PIX_QR_RECEIVE_FORM_ID}
                className="btn-primary w-full sm:w-auto"
                disabled={!canContinue}
              >
                Continuar
              </button>
            </div>
          )}

          {step === 1 && (
            <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-between">
              <button
                type="button"
                className="btn-back w-full sm:w-auto"
                onClick={() => contentRef.current?.goBack()}
              >
                <TbArrowLeft className="h-4 w-4" />
                Voltar
              </button>
              <button
                type="button"
                className="btn-primary w-full sm:w-auto"
                onClick={() => contentRef.current?.confirm()}
                disabled={isSubmitting || !canContinue}
              >
                Confirmar
              </button>
            </div>
          )}

          {step === 2 && (
            <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-between">
              <button type="button" className="btn-outline w-full sm:w-auto" onClick={onClose}>
                Fechar
              </button>
              <button
                type="button"
                className="btn-primary w-full sm:w-auto"
                onClick={() => contentRef.current?.reset()}
              >
                Nova cobrança
              </button>
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
};
